import produce from 'immer';
import TFormsActions, { IFormState, TFormsState } from '../../types/redux/forms';
import {
    FORM_CLEAR_STATE, FORM_DELETE_STATE, FORM_PUSH_FIELD_TITLE, FORM_PUSH_FIELD_VALIDATION, FORM_PUSH_FIELD_VALIDATION_RESULT,
    FORM_RESET_VALIDATION_RESULTS, FORM_SET_FIELD_DATA, FORM_SET_FIELD_INITIAL_VALUE, FORM_SET_FIELD_LAYOUT, FORM_SET_FIELD_MESSAGE,
    FORM_SET_FIELD_VALUE, FORM_SET_INITIAL_VALUES, FORM_STATE_SET_MODE,
} from '../actions/forms';

const getInitialFormState = (): IFormState => ({
    editedValues: {},
    initialValues: {},
    validation: {
        rules: {},
        result: {},
    },
    mode: 'default',
    titles: {},
    messages: {},
    fieldLayouts: {},
    formDataLoaded: false,
});

const initialState: TFormsState = {};

export const forms = (state = initialState, action: TFormsActions): TFormsState => {
    switch (action.type) {
        case FORM_SET_FIELD_VALUE: {
            const nextState = {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    editedValues: {
                        ...state[action.layoutId]?.editedValues,
                        [action.payload.fieldName]: action.payload.value,
                    },
                    validation: {
                        result: {},
                        rules: {},
                        ...state[action.layoutId]?.validation,
                    },
                },
            };
            delete nextState[action.layoutId]?.validation.result[action.payload.fieldName];
            return nextState;
        }
        case FORM_SET_FIELD_INITIAL_VALUE: {
            const nextState = {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    initialValues: {
                        ...state[action.layoutId]?.initialValues,
                        [action.payload.fieldName]: action.payload.value,
                    },
                    validation: {
                        rules: {},
                        result: {},
                        ...state[action.layoutId]?.validation,
                    },
                },
            };
            delete nextState[action.layoutId]?.validation.result[action.payload.fieldName];
            return nextState;
        }
        case FORM_SET_INITIAL_VALUES: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    initialValues: action.payload.initialValues,
                    formDataLoaded: true,
                },
            };
        }
        case FORM_CLEAR_STATE: {
            return {
                ...state,
                [action.layoutId]: getInitialFormState(),
            };
        }
        case FORM_DELETE_STATE: {
            return produce(state, (draft) => {
                delete draft[action.layoutId];
            });
        }
        case FORM_STATE_SET_MODE: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    mode: action.payload.mode,
                },
            };
        }
        case FORM_PUSH_FIELD_VALIDATION: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    validation: {
                        result: {},
                        ...state[action.layoutId]?.validation,
                        rules: {
                            ...state[action.layoutId]?.validation?.rules,
                            [action.payload.fieldName]: action.payload.validation,
                        },
                    },
                },
            };
        }
        case FORM_PUSH_FIELD_VALIDATION_RESULT: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    validation: {
                        rules: {},
                        ...state[action.layoutId]?.validation,
                        result: {
                            ...state[action.layoutId]?.validation?.result,
                            [action.payload.fieldName]: action.payload.result,
                        },
                    },
                },
            };
        }
        case FORM_RESET_VALIDATION_RESULTS: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    validation: {
                        rules: {},
                        ...state[action.layoutId]?.validation,
                        result: {},
                    },
                },
            };
        }
        case FORM_PUSH_FIELD_TITLE: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    titles: {
                        ...state[action.layoutId]?.titles,
                        [action.payload.fieldName]: action.payload.title,
                    },
                },
            };
        }
        case FORM_SET_FIELD_MESSAGE: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    messages: {
                        ...state[action.layoutId]?.messages,
                        [action.payload.fieldName]: action.payload,
                    },
                },
            };
        }
        case FORM_SET_FIELD_LAYOUT: {
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    fieldLayouts: {
                        ...state[action.layoutId]?.fieldLayouts,
                        [action.payload.fieldName]: action.payload.layout,
                    },
                },
            };
        }
        case FORM_SET_FIELD_DATA: {
            // @ts-ignore
            return {
                ...state,
                [action.layoutId]: {
                    ...getInitialFormState(),
                    ...state[action.layoutId],
                    fieldLayouts: {
                        ...state[action.layoutId]?.fieldLayouts,
                        [action.payload.fieldName]: {
                            ...state[action.layoutId]?.fieldLayouts?.[action.payload.fieldName],
                            data: action.payload.data,
                        },
                    },
                },
            };
        }
        default: {
            return state;
        }
    }
};
